<template lang="pug">
span.tags.is-inline-flex.has-addons.platform-label.mb-0(v-if="platform", style="min-width: 200px;")
  platform-priority-icon.mb-0(v-if="withPriority", :value="platform.priority", :class="tagClass")
  b-tag.mb-0.is-rounded(:type="platform.labelColor", :class="tagClass")
    b-icon.mr-5(v-if="withIcon", icon="cube")
    span {{ platform.name }}
  a.tag.mb-0.is-white.is-rounded(
    v-if="withLink && platform.host",
    :class="tagClass",
    :href="platform.getUrl()",
    target="_blank"
  )
    b-icon(icon="arrow-top-right-thick", :type="platform.labelColor")
</template>

<script>
export default {
  name: 'platform-label',

  props: {
    platform: Object,
    withPriority: Boolean,
    withIcon: Boolean,
    withLink: {
      type: Boolean,
      default: () => false,
    },
    isLarge: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    tagClass() {
      return [this.isLarge ? 'is-large' : false];
    },
  },
};
</script>
